import { getMTMList } from '../../services/quotes.service';

export const GET_LIST_MTM = 'GET_LIST_MTM';
export const GET_LIST_MTM_SUCCESS = 'GET_LIST_MTM_SUCCESS';
export const GET_LIST_MTM_FAIL = 'GET_LIST_MTM_FAIL';

export function getAppliances() {
  return async dispatch => {
    dispatch({
      type: GET_LIST_MTM,
    });

    try {
      const appliancesList = await getMTMList();
      const appliancesListByBrand = appliancesList.reduce((accumulator, currentValue) => {
        const { brand, mtm, partNumber, shortDescription } = currentValue;
        if (!accumulator[brand]) {
          accumulator[brand] = [];
        }
        accumulator[brand].push({ partNumber, label: shortDescription !== '' ? `${mtm} (${shortDescription})` : mtm });
        return accumulator;
      }, {});

      dispatch({
        type: GET_LIST_MTM_SUCCESS,
        appliancesList,
        appliancesListByBrand,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: GET_LIST_MTM_FAIL,
      });
    }
  };
}
